'use client';
import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 32px;
  border: 0.5px solid ${props => props.theme.colors.secondary.plum};
  display: inline-flex;
  flex-direction: column;
  user-select: none;
  overflow: hidden;
  position: relative;
  width: 365px;
  max-height: fit-content;
  background: ${({ theme, unavailable, checked }) =>
    unavailable
      ? theme.colors.background.disabled
      : checked
      ? theme.colors.background.checked
      : theme.colors.background.base};
  opacity: ${({ $notSelectable }) => ($notSelectable ? 0.5 : 1)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
  gap: 1px;
  padding: ${({ theme }) => theme.spacing(1, 2)};
`;

export const StyledImage = styled.div`
  display: flex;
  align-items: center;
  border-radius: 16px;
  overflow: hidden;
  object-position: left;
  object-fit: cover;
  min-height: 100px;
  min-width: 100px;
  filter: ${props => props.unavailable && 'grayscale(100%) brightness(93%)'};
  padding: ${({ theme }) => theme.spacing(0, 2)};
`;

export const Info = styled.div`
  max-width: 251px;
  padding-left: ${({ theme }) => theme.spacing(2)};
`;

export const CardHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const Name = styled.h5`
  ${({ theme }) => theme.typography.heading5}
  text-transform: capitalize;
`;

export const Description = styled.p`
  ${({ theme }) => theme.typography.body}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: ${({ theme }) => theme.spacing(1)};
  text-align: left;
  min-height: 52px;
`;
